<template>
    <div :class="authUser && authUser.emailVerified && authUser.passwordChanged && authUser.rgpdAccepted ? (is_mobile_device ? 'commons_content_mobile' : '') + ' commons_content absolute0' : ''">
        <!--NavBar top-->
        <div class="commons_top" v-if="authUser && authUser.emailVerified && authUser.passwordChanged && authUser.rgpdAccepted">
            <nav-bar-top :title="currentRouteName" />
        </div>

        <!-- Side navigation -->
        <div class="commons_menu" v-if="authUser && authUser.emailVerified && authUser.passwordChanged && authUser.rgpdAccepted">
            <side-bar-left />
        </div>

        <!-- Page content -->
        <div class="commons_inner no_scroll">
            <div
                :class="can(Ability.RH_SPS_DOS_OWN_MANAGE) && can(Ability.RH_ADM_DOS_OWN_MANAGE) ? 'content_intervenant' : 'content xl:px-0 absolute0'"
                v-if="(!authUser) || (authUser && user_session_id) || (authUser && multi_session) || (authUser && (!authUser.emailVerified || !authUser.passwordChanged || !authUser.rgpdAccepted))"
            >
                <router-view/>
            </div>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator'
import NavBarTop from '@/components/NavBarTop'
import SideBarLeft from '@/components/SideBarLeft.vue'
import { mapGetters, mapActions, mapState } from 'vuex'
import { Ability } from '@/types/Ability'
import { functionsForDashboard } from '@/types/Dashboard'

@Component({
    computed: {
        ...mapGetters('auth', [
            'authUser',
            'can',
            'cannot',
            'isA',
            'isNotA'
        ]),
        ...mapGetters('user', ['dashboard', 'centreId']),
        ...mapState('auth', ['user_session_id', 'multi_session']),
        currentRouteName() {
            let routeName = ' '
            if (this.$route.meta && this.$route.meta.refererComponent) {
                routeName = this.$route.meta.refererComponent + ' | '
            }
            if (this.$route.name) {
                routeName += this.$route.name
            }

            return routeName
        }
    },
    components: {
        'nav-bar-top': NavBarTop,
        'side-bar-left': SideBarLeft
    },
    methods: {
        ...mapActions('dossieracademique', ['getDossiersAcademiques']),
        ...mapActions('dossieradministratif', ['getDossiersAdministratifs']),
        ...mapActions('centre', ['getCentres']),
        ...mapGetters('auth', ['is_intervenant_centre'])
    }
})
export default class App extends Vue {
    Ability = Ability

    count_passage_abilities = 0
    hasDroitSps = false
    hasDroitAdm = false
    is_mobile_device = false

    @Watch('dashboard')
    loadCompteurs () {
        this.count_passage_abilities++
        if (this.$store.state.auth.user && this.$store.state.auth.user.abilities && this.count_passage_abilities === this.$store.state.auth.user.abilities.length) {
            // Compteurs chargés on appelle le dashboard
            this.count_passage_abilities = 0
            this.initMenu()
        }
    }

    initMenu () {
        if (this.$store.getters['auth/is_intervenant_centre']) {
            this.$store.state.user.centreId = null
            this.$store.state.user.conventionPublished = null
            this.$store.dispatch('centre/getCentres').then(() => {
                this.$store.state.user.centreId = this.$store.state.centre.centres[0] ? this.$store.state.centre.centres[0].id : null
                this.$store.state.user.centreTypePassation = this.$store.state.centre.centres[0] ? this.$store.state.centre.centres[0].type_passation : null
                this.$store.state.user.centre_organisation_ecrit_validated = this.$store.state.centre.centres[0] ? this.$store.state.centre.centres[0].nb_intervenants_validated_at : null
                if (this.$store.state.centre.centres[0]) {
                    this.$store.commit('centre/SET_CENTRE_SELECT', this.$store.state.centre.centres[0])
                }
                this.$store.state.user.conventionPublished = this.$store.state.centre.centres[0] ? this.$store.state.centre.centres[0].convention_published_at : null
            })
        }


        if (this.hasDroitSps) {
            this.$store.state.user.dossieracademiqueId = null
            this.$store.dispatch('dossieracademique/getDossiersAcademiques').then(() => {
                if (this.$store.state.dossieracademique.dossiersAcademiques[this.$store.state.auth.user.id]) {
                    this.$store.state.user.dossieracademiqueId = this.$store.state.dossieracademique.dossiersAcademiques[this.$store.state.auth.user.id] && this.$store.state.dossieracademique.dossiersAcademiques[this.$store.state.auth.user.id].courant ? this.$store.state.dossieracademique.dossiersAcademiques[this.$store.state.auth.user.id].courant.id : null
                }
            })
        }

        if (this.hasDroitAdm && !this.$store.state.dossieradministratif.loading) {
            this.$store.state.user.dossieradministratifId = null
            this.$store.dispatch('dossieradministratif/getDossiersAdministratifs').then(() => {
                this.$store.state.user.dossieradministratifId = this.$store.state.dossieradministratif.dossiersAdministratifs[0] ? this.$store.state.dossieradministratif.dossiersAdministratifs[0].id : null

                if (this.$store.state.dossieradministratif.dossiersAdministratifs.length !== 0 && this.$store.state.dossieradministratif.dossiersAdministratifs[0] && this.$store.state.dossieradministratif.dossiersAdministratifs[0].contrats.length !== 0) {
                    this.$store.commit('dossieradministratif/SET_CONTRATS', this.$store.state.dossieradministratif.dossiersAdministratifs[0].contrats)
                    this.$store.state.user.hasContrat = true
                }
            })
        }

        this.dashboardElements = functionsForDashboard.dashboardFiltered(functionsForDashboard.dashboardElements)
        this.dashboardReady = true
    }

    mounted () {
        // Detection si le device est un mobile
        if ('ontouchstart' in document.documentElement)
        {
            this.is_mobile_device = true
        }
        else
        {
            this.is_mobile_device = false
        }

        if (this.$store.state.auth.user && this.$store.state.auth.user.abilities && this.$store.state.auth.user.abilities.length !== 0) {
            this.$store.state.user.dashboard = []
            for (const i in this.$store.state.auth.user.abilities) {
                if (this.$store.state.auth.user.abilities[i].name === Ability.RH_SPS_DOS_OWN_MANAGE) {
                    this.hasDroitSps = true
                }
                if (this.$store.state.auth.user.abilities[i].name === Ability.RH_ADM_DOS_OWN_MANAGE) {
                    this.hasDroitAdm = true
                }
            }
        }
    }
}
</script>

<style lang="scss">
.col-w-etat {
    width: 3rem;
    border-bottom-left-radius: 0.5rem;
    border-top-left-radius: 0.5rem;
}
.cursor-pointer {
    cursor: pointer;
}
div.content
{
    margin:     24px;
    box-sizing: border-box;
}
div.content_intervenant
{
    margin:             24px;
    background-color: #FCFDFF;
    box-sizing:         border-box;
    position:           absolute;
    top:                0;
    left:               0;
    right:              0;
    bottom:             0;
}


.max-width-card {
    max-width: 50rem;
}

// X-Small devices (portrait phones, less than 576px)
@media (max-width: 575.98px) {
    div.content {
        margin-left: 0px;
        margin-right: 0px;
        padding: 1px 16px;
    }
    div.content_intervenant {
        padding: 1px 16px;
        background-color: #FCFDFF;
        height: 100vh;
    }
}

// Small devices (landscape phones, less than 768px)
@media (max-width: 767.98px) {}

// Medium devices (tablets, less than 992px)
@media (max-width: 991.98px) {}

// Large devices (desktops, less than 1200px)
@media (max-width: 1199.98px) {}

// X-Large devices (large desktops, less than 1400px)
@media (max-width: 1399.98px) {}

// XX-Large devices (larger desktops)
// No media query since the xxl breakpoint has no upper bound on its width
</style>
